import { render } from "./DettaglioBilancioPrevisionali.vue?vue&type=template&id=0ae7a166&ts=true"
import script from "./DettaglioBilancioPrevisionali.vue?vue&type=script&lang=ts"
export * from "./DettaglioBilancioPrevisionali.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__